import React, { useContext, useState } from 'react';
import { RicosContext, ToolbarContext, ModalContext } from 'ricos-context';
import { resolveColorsPalette } from 'wix-rich-content-common';
import { FloatingColorPicker } from 'wix-rich-content-ui-components';
import { DEFAULT_PALETTE, TEXT_COLOR_MODAL_ID, TEXT_HIGHLIGHT_MODAL_ID } from './constants.js';
import 'ricos-types';

const TextColorPicker = ({ type, config, referenceElement }) => {
  var _a, _b;
  const { t } = useContext(RicosContext);
  const { getEditorCommands } = useContext(ToolbarContext);
  const modalService = useContext(ModalContext);
  const currentColor = (_b = (_a = getEditorCommands()) == null ? void 0 : _a.getColor(type)) == null ? void 0 : _b.toUpperCase();
  const [userColors, setUserColors] = useState(
    () => {
      var _a2, _b2;
      return resolveColorsPalette({
        colors: [
          ...DEFAULT_PALETTE,
          ...config.colorScheme ? Object.values(config.colorScheme).map((c) => c.color) : [],
          ...(_b2 = (_a2 = config.getColorFn) == null ? void 0 : _a2.call(config)) != null ? _b2 : []
        ],
        currentColor
      });
    }
  );
  const closeModal = () => {
    modalService.closeModal(
      type === "ricos-text-color" ? TEXT_COLOR_MODAL_ID : TEXT_HIGHLIGHT_MODAL_ID
    );
  };
  return /* @__PURE__ */ React.createElement(
    FloatingColorPicker,
    {
      title: type === "ricos-text-color" ? t("Color_Picker_TextColorButton_Header") : t("Color_Picker_TextHighlightButton_Header"),
      currentColor,
      userColors,
      onChange: ({ type: onChangeType, color }) => {
        var _a2, _b2, _c;
        if (onChangeType === "colorSelected") {
          (_a2 = getEditorCommands()) == null ? void 0 : _a2.insertDecoration(type, { color });
        }
        if (onChangeType === "colorAdded") {
          (_b2 = config.onColorAdded) == null ? void 0 : _b2.call(config, color);
          setUserColors((prev) => [...prev, color]);
          (_c = getEditorCommands()) == null ? void 0 : _c.insertDecoration(type, { color });
        }
      },
      onReset: () => {
        var _a2;
        (_a2 = getEditorCommands()) == null ? void 0 : _a2.deleteDecoration(type);
      },
      closeModal,
      referenceElement
    }
  );
};

export { TextColorPicker };
//# sourceMappingURL=TextColorPicker.js.map
